// extracted by mini-css-extract-plugin
module.exports = {"root":"fncInputText_root__2n4t6","input":"fncInputText_input__3ZQ9B","hasError":"fncInputText_hasError__3d2uY"};